module.exports = __webpack_public_path__ + "img/DE01415.e8227df9.png";